module.exports = __webpack_public_path__ + "img/08.b6d16a5b.png";